import { render, staticRenderFns } from "./WaitSpinner.vue?vue&type=template&id=6fcd2854&scoped=true&"
import script from "./WaitSpinner.vue?vue&type=script&lang=js&"
export * from "./WaitSpinner.vue?vue&type=script&lang=js&"
import style0 from "./WaitSpinner.vue?vue&type=style&index=0&id=6fcd2854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd2854",
  null
  
)

export default component.exports